var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "iframe-container" },
    [
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
          ])
        : _vm._l(_vm.carsData, function(car, i) {
            return _c("div", { staticClass: "car" }, [
              _c("h3", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.$t("car")) + " " + _vm._s(i + 1))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "car-type" }, [
                _c("div", { staticClass: "select-group make" }, [
                  _c("label", { attrs: { for: "car-make" + i } }, [
                    _vm._v(_vm._s(_vm.$t("make")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: car.selectedMake,
                          expression: "car.selectedMake"
                        }
                      ],
                      attrs: {
                        id: "car-make" + i,
                        disabled:
                          _vm.loading ||
                          !_vm.makes ||
                          _vm.makes.length < 1 ||
                          car.isUserCarInputs ||
                          car.loading ||
                          _vm.disableSelection
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              car,
                              "selectedMake",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.handleMakeChange(i)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }),
                      _vm._v(" "),
                      _vm._l(_vm.makes, function(make) {
                        return _c("option", { domProps: { value: make } }, [
                          _vm._v(_vm._s(make))
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-group model" }, [
                  _c("label", { attrs: { for: "car-model" + i } }, [
                    _vm._v(_vm._s(_vm.$t("model")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: car.selectedModel,
                          expression: "car.selectedModel"
                        }
                      ],
                      attrs: {
                        id: "car-model" + i,
                        disabled:
                          _vm.loading ||
                          !car.models ||
                          car.models.length < 1 ||
                          car.isUserCarInputs ||
                          car.loading ||
                          _vm.disableSelection
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              car,
                              "selectedModel",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.handleModelChange(i)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }),
                      _vm._v(" "),
                      _vm._l(car.models, function(model) {
                        return _c("option", { domProps: { value: model } }, [
                          _vm._v(_vm._s(model))
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-group year" }, [
                  _c("label", { attrs: { for: "car-year" + i } }, [
                    _vm._v(_vm._s(_vm.$t("year")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: car.selectedYear,
                          expression: "car.selectedYear"
                        }
                      ],
                      attrs: {
                        id: "car-year" + i,
                        disabled:
                          _vm.loading ||
                          !car.years ||
                          car.years.length < 1 ||
                          car.isUserCarInputs ||
                          car.loading ||
                          _vm.disableSelection
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              car,
                              "selectedYear",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.handleYearChange(i)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }),
                      _vm._v(" "),
                      _vm._l(car.years, function(year) {
                        return _c("option", { domProps: { value: year } }, [
                          _vm._v(_vm._s(year))
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                !car.loading && car.trims && car.trims.length > 0
                  ? _c("div", { staticClass: "select-group trim" }, [
                      _c("label", { attrs: { for: "car-trim" + i } }, [
                        _vm._v(_vm._s(_vm.$t("trim")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: car.selectedTrimId,
                              expression: "car.selectedTrimId"
                            }
                          ],
                          attrs: {
                            id: "car-trim" + i,
                            disabled:
                              _vm.loading ||
                              !car.trims ||
                              car.trims.length < 1 ||
                              car.isUserCarInputs ||
                              car.loading ||
                              _vm.disableSelection
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  car,
                                  "selectedTrimId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.handleTrimChange(i)
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }),
                          _vm._v(" "),
                          _vm._l(car.trims, function(trim) {
                            return _c(
                              "option",
                              { domProps: { value: trim.id } },
                              [_vm._v(_vm._s(trim.name))]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-car-type" }, [
                _c("div", { staticClass: "user-car-checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: car.isUserCarInputs,
                        expression: "car.isUserCarInputs"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "show-user-car-input-" + i,
                      disabled:
                        _vm.loading || car.loading || _vm.disableSelection
                    },
                    domProps: {
                      checked: Array.isArray(car.isUserCarInputs)
                        ? _vm._i(car.isUserCarInputs, null) > -1
                        : car.isUserCarInputs
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = car.isUserCarInputs,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  car,
                                  "isUserCarInputs",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  car,
                                  "isUserCarInputs",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(car, "isUserCarInputs", $$c)
                          }
                        },
                        function($event) {
                          return _vm.handleUserInputCheckboxChanged(i)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "show-user-car-input-" + i } }, [
                    _vm._v(_vm._s(_vm.$t("i_dont_see_my_model_listed")))
                  ])
                ]),
                _vm._v(" "),
                car.isUserCarInputs
                  ? _c("div", { staticClass: "user-car-input" }, [
                      _c("div", { staticClass: "user-car-make-model-input" }, [
                        _c(
                          "label",
                          { attrs: { for: "user-car-make-model-" + i } },
                          [_vm._v(_vm._s(_vm.$t("Vehicle_make_model")) + "*")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: car.userCarMakeModelInput,
                              expression: "car.userCarMakeModelInput"
                            }
                          ],
                          attrs: {
                            disabled: _vm.loading || _vm.disableSelection,
                            type: "text",
                            placeholder: "Honda civic",
                            id: "user-car-make-model-" + i
                          },
                          domProps: { value: car.userCarMakeModelInput },
                          on: {
                            blur: function($event) {
                              return _vm.handleUserInputMakeModelChanged(i)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                car,
                                "userCarMakeModelInput",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-car-type-input" }, [
                        _c("label", { attrs: { for: "user-car-type-" + i } }, [
                          _vm._v(_vm._s(_vm.$t("type")) + "*")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: car.userCarBodyTypeId,
                                expression: "car.userCarBodyTypeId"
                              }
                            ],
                            attrs: {
                              disabled: _vm.loading || _vm.disableSelection,
                              id: "user-car-type-" + i
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    car,
                                    "userCarBodyTypeId",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.handleUserInputCarTypeChanged(i)
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.carBodyTypes, function(carType) {
                            return _c(
                              "option",
                              { domProps: { value: carType.id } },
                              [_vm._v(_vm._s(carType.name))]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-024ac3d0", { render: render, staticRenderFns: staticRenderFns })
  }
}